import * as L from 'leaflet'
import { AreaViewBase } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { AreaViewBaseOptions } from '@map-sdk/sdk/plugins/AreaView/AreaViewBase'

class ChinaDischargeAreaSymbol extends AreaViewBase {
  _show(): this {
    if (!this._data) {
      console.error('区域图形展示，请求无数据！')
      return this
    }

    for (let i = 0; i < this._data.length; i++) {
      let polyline1: L.Polyline | L.Polygon | null = null
      let polyline2: L.Polyline | L.Polygon | null = null
      const dataList = this._data[i].data
      const latlng1: L.LatLngTuple[] = []
      const latlng2: L.LatLngTuple[] = []

      for (const latlng of dataList) {
        latlng1.push([latlng.lat, latlng.lon])
        latlng2.push([latlng.lat, Number(latlng.lon) + 360])
      }

      if (i === 0) {
        polyline1 = L.polyline(latlng1, {
          color: '#169316',
          dashArray: '7',
          dashOffset: '4',
          weight: 2,
          ...this.options,
        }) as any
        polyline2 = L.polyline(latlng2, {
          color: '#169316',
          dashArray: '7',
          dashOffset: '4',
          weight: 2,
          ...this.options,
        }) as any
      } else if (i === 1) {
        polyline1 = L.polygon(latlng1, {
          color: '#169316',
          fill: false,
          dashArray: '7',
          dashOffset: '4',
          weight: 2,
          ...this.options,
        })
        polyline2 = L.polygon(latlng2, {
          color: '#169316',
          fill: false,
          dashArray: '7',
          dashOffset: '4',
          weight: 2,
          ...this.options,
        })
      }

      if (polyline1) {
        polyline1.addTo(this._map)
        this._areaLayers.push(polyline1)
      }
      if (polyline2) {
        polyline2.addTo(this._map)
        this._areaLayers.push(polyline2)
      }
    }

    return this
  }
}

// 创建工厂函数
function chinaDischargeAreaSymbol(
  map: MyMap,
  options: Partial<AreaViewBaseOptions>
): ChinaDischargeAreaSymbol {
  return new ChinaDischargeAreaSymbol(map, options)
}

export { ChinaDischargeAreaSymbol, chinaDischargeAreaSymbol }
